import ModalPassword from "./ModalPassword";

export default ModalPassword;
